import React from "react";
import { Outlet } from "react-router-dom";

function BaseLayout({ children }) {
  return <div>{children || <Outlet />}</div>;
}

export default BaseLayout;
